import {
  CultureSatisfactionElement,
  CultureSatisfactionElementJSON,
  CultureSatisfactionJSON,
} from '../features/company/culture/dashboard/types/CultureSatisfactionTypes';

export default class CultureSatisfactionSerializers {
  static toObject(payload: CultureSatisfactionElementJSON): CultureSatisfactionElement {
    return {
      resourceId: payload.resource_id,
      key: payload.key,
      average: payload.average,
      labels: payload.labels,
      title: payload.title,
    };
  }

  static toObjects(payload: CultureSatisfactionJSON): CultureSatisfactionElement[] {
    return payload.culture_satisfaction.map((culture_satisfaction_element) =>
      CultureSatisfactionSerializers.toObject(culture_satisfaction_element)
    );
  }
}
